
// Det her komponent kunne bruges både stand alone og som et content/background component.

Vue.component("LoginDialogue", {

    data() {
        return {
            visible: false,
            redirectRoute: "",
        }
    },

    template: `
      
        <div class="loginForm" v-if="visible">
            <transition 
                appear
                enter-active-class="animated zoomIn  transition-duration-350"
            >
            
                <TkLogin :redirect-route="redirectRoute" @close="close" v-if="visible">
                    <div class="form-group">
                        <button type="button" class="btn-close form-control btn btn-muted  rounded"  @click="close">Cancel</button>
                    </div>
                </TkLogin>
            </transition>
        </div>
    `,

    mounted() {

        this.events = {
            "show-login-dialogue": (redirectRoute) => {
                this.redirectRoute = redirectRoute;
                this.visible = true;
            }
        }

        // idden er/var lidt at routeren måske ville spawne den her dialogue onReject hvis man 
        // har sat auth.type == dialogue
        app.radio.$on("show-login-dialogue", this.events["show-login-dialogue"]);
    },

    destroyed() {
        app.radio.$off("show-login-dialogue", this.events["show-login-dialogue"]);
    },
    methods: {

        close() {
            this.visible = false;
            this.redirectRoute = "";
        }
    }

})